import getMediaElement from 'editor/src/store/design/selector/getMediaElement';
import { updateMediaElementAction } from 'editor/src/store/design/slice';
import { ElementAddress, MediaImage } from 'editor/src/store/design/types';
import type { ThunkDispatch } from 'editor/src/store/hooks';
import { RootState } from 'editor/src/store/index';
import { getAdvPersoDataFromElement, getElementCollectionAssets } from 'editor/src/store/plugins/utils/advPersoUtils';

import getCenteredImagePosition from 'editor/src/util/2d/getCenteredImagePosition';

import { getLinkedCollectionElements } from '../util/collectionLink';

const updateCollectionImageOperation =
  (
    elementAddress: ElementAddress,
    assetId: string,
    url: string,
    assetWidth: number,
    assetHeight: number,
    syncLinked = true,
  ) =>
  (dispatch: ThunkDispatch, getState: () => RootState) => {
    const state = getState();
    const element = getMediaElement<MediaImage>(state, elementAddress);
    if (!element) {
      return;
    }

    const { px, py, pw, ph } = getCenteredImagePosition(element, {
      width: assetWidth,
      height: assetHeight,
    });

    dispatch(
      updateMediaElementAction({
        elementAddress,
        elementUpdate: { imageId: assetId, url, px, py, pw, ph, pr: 0 },
      }),
    );

    const collectionInfo = getAdvPersoDataFromElement(element);
    if (!syncLinked || !collectionInfo?.linkGroupId || !state.design.designData) {
      return;
    }

    // Linked layers follow by position: the Nth option of every layer in the group
    // represents the same choice (e.g. page 1 and page 2 of the same source PDF).
    const sourceFolder = state.collections.folders[collectionInfo.folderId];
    const selectedIndex = sourceFolder
      ? getElementCollectionAssets(sourceFolder, collectionInfo).findIndex((asset) => asset.id === assetId)
      : -1;
    if (selectedIndex < 0) {
      return;
    }

    getLinkedCollectionElements(state.design.designData, collectionInfo.linkGroupId).forEach((linked) => {
      if (
        linked.address.spreadIndex === elementAddress.spreadIndex &&
        linked.address.pageIndex === elementAddress.pageIndex &&
        linked.address.elementIndex === elementAddress.elementIndex
      ) {
        return;
      }
      const folder = state.collections.folders[linked.collectionInfo.folderId];
      if (!folder) {
        return;
      }
      const asset = getElementCollectionAssets(folder, linked.collectionInfo)[selectedIndex];
      if (!asset) {
        return;
      }
      dispatch(updateCollectionImageOperation(linked.address, asset.id, asset.url, asset.width, asset.height, false));
    });
  };

export default updateCollectionImageOperation;
